var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box grow cursor-pointer",on:{"click":function($event){return _vm.gotoTrail()}}},[_c('div',{staticClass:"box flex row"},[_c('span',{staticClass:"small-font"},[_vm._v("["+_vm._s(_vm.trailLabel)+"] The trail has been assigned to "+_vm._s(_vm.notificationDetails.eventCategory)+".")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58712319","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/notification/NotificationAssignmentEvent.vue
// module id = null
// module chunks = 